"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var constants_1 = require("../constants");
var ExplanationComponent_1 = require("../scoreSystems/IfscTopBonus/ExplanationComponent");
var ExplanationComponent_2 = require("../scoreSystems/IfscTopZone/ExplanationComponent");
var ExplanationComponent_3 = require("../scoreSystems/IfscLead/ExplanationComponent");
var ExplanationComponent_4 = require("../scoreSystems/NorthFaceCup2019/ExplanationComponent");
var ExplanationComponent_5 = require("../scoreSystems/PointsDecreaseWithAttempts/ExplanationComponent");
var ExplanationComponent_6 = require("../scoreSystems/PointsGravical2019/ExplanationComponent");
var ExplanationComponent_7 = require("../scoreSystems/TopsWithAttempts/ExplanationComponent");
var ExplanationComponent_8 = require("../scoreSystems/UsacModifiedRedpoint/ExplanationComponent");
var ExplanationComponent_9 = require("../scoreSystems/UsacModifiedRedpointMultizone/ExplanationComponent");
var ExplanationComponent = function (props) {
    switch (props.scoreSystemKey) {
        case constants_1.IFSC_TB:
            return React.createElement(ExplanationComponent_1.default, null);
        case constants_1.IFSC_TZ:
            return React.createElement(ExplanationComponent_2.default, null);
        case constants_1.IFSC_LEAD:
            return React.createElement(ExplanationComponent_3.default, null);
        case constants_1.NORTH_FACE_CUP_2019:
            return React.createElement(ExplanationComponent_4.default, null);
        case constants_1.POINTS_DECREASE:
            return React.createElement(ExplanationComponent_5.default, null);
        case constants_1.POINTS_GRAVICAL_2019:
            return React.createElement(ExplanationComponent_6.default, null);
        case constants_1.TOPS_WITH_ATTEMPTS:
            return React.createElement(ExplanationComponent_7.default, null);
        case constants_1.USAC_MOD_REDPOINT:
            return React.createElement(ExplanationComponent_8.default, null);
        case constants_1.USAC_MOD_REDPOINT_MULTIZONE:
            return React.createElement(ExplanationComponent_9.default, null);
        default:
            return React.createElement("span", null, "This score format is not recognized!");
    }
};
exports.default = ExplanationComponent;
//# sourceMappingURL=ExplanationComponent.js.map


//////////////////
// WEBPACK FOOTER
// ../lib-score-systems/dist/components/ExplanationComponent.js
// module id = 1026
// module chunks = 0